export const VERSION = "1.0.2";
